import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from '../../contexts/DataContext';
import KPICard from '../../components/reports/KPICard';
import ReportChart from '../../components/reports/ReportChart';
import ReportTable from '../../components/reports/ReportTable';
import BranchSelect from '../../components/reports/BranchSelect';
import { calculateWarningKPIs, calculateAging, getUniqueBranches, filterByBranch, exportToCSV } from '../../utils/reportHelpers';

function LowRiskReport() {
  const navigate = useNavigate();
  const { warnings, customers } = useData();
  
  const [selectedBranch, setSelectedBranch] = useState([]);
  const branches = getUniqueBranches(customers);
  
  let lowRiskWarnings = warnings.filter(w => w.riskLevel === 'low' && w.status !== 'resolved');
  lowRiskWarnings = filterByBranch(lowRiskWarnings, customers, selectedBranch);
  const kpis = calculateWarningKPIs(lowRiskWarnings);

  // Aging analysis
  const agingDistribution = {
    labels: ['0-30 ngày', '31-60 ngày', '61-90 ngày', '>90 ngày'],
    datasets: [{
      label: 'Số lượng',
      data: [
        lowRiskWarnings.filter(w => calculateAging(w).days <= 30).length,
        lowRiskWarnings.filter(w => {
          const days = calculateAging(w).days;
          return days > 30 && days <= 60;
        }).length,
        lowRiskWarnings.filter(w => {
          const days = calculateAging(w).days;
          return days > 60 && days <= 90;
        }).length,
        lowRiskWarnings.filter(w => calculateAging(w).days > 90).length
      ],
      backgroundColor: '#ffc107'
    }]
  };

  const tableColumns = [
    { key: 'code', label: 'Mã CB', sortable: true },
    { key: 'customerName', label: 'Tên KH', sortable: true },
    { key: 'score', label: 'Điểm', sortable: true, type: 'number' },
    { key: 'lastCheckedDate', label: 'Check cuối', sortable: true, type: 'date' }
  ];

  const handleExport = () => {
    const exportData = lowRiskWarnings.map(w => ({
      'Mã': w.code,
      'Khách hàng': w.customerName,
      'Điểm': w.score,
      'Ngày check cuối': w.lastCheckedDate
    }));
    exportToCSV(exportData, 'bao-cao-rui-ro-thap');
  };

  return (
    <div className="container-fluid">
      <div className="page-header-sticky">
        <div className="row mb-4">
          <div className="col-12">
            <button className="btn btn-outline-secondary mb-3" onClick={() => navigate('/reports')}>
              <i className="bi bi-arrow-left me-2"></i>
              Quay lại
            </button>
            <h2>
              <i className="bi bi-info-circle me-2 text-success"></i>
              Báo cáo các trường hợp cảnh báo sớm rủi ro thấp
            </h2>
            <p className="text-muted">Monitoring nhẹ, tối ưu resource</p>
          </div>
        </div>
      </div>

      {/* Branch Filter */}
      <div className="row mb-4">
        <div className="col-md-4">
          <BranchSelect 
            value={selectedBranch}
            onChange={setSelectedBranch}
            branches={branches}
          />
        </div>
      </div>

      {/* Success Message */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="alert alert-success">
            <i className="bi bi-check-circle me-2"></i>
            Đa số cases ổn định. Theo dõi định kỳ theo schedule.
          </div>
        </div>
      </div>

      {/* KPIs */}
      <div className="row g-3 mb-4 stagger-animation">
        <div className="col-md-4">
          <KPICard 
            title="Tổng rủi ro thấp"
            value={lowRiskWarnings.length}
            icon="bi-shield-check"
            color="success"
          />
        </div>
        <div className="col-md-4">
          <KPICard 
            title="Điểm TB"
            value={kpis.avgScore}
            icon="bi-speedometer2"
            color="info"
          />
        </div>
        <div className="col-md-4">
          <KPICard 
            title="% tổng số"
            value={`${kpis.lowRiskPercent}%`}
            icon="bi-pie-chart"
            color="primary"
          />
        </div>
      </div>

      {/* Chart */}
      <div className="row g-3 mb-4 stagger-animation">
        <div className="col-md-12">
          <ReportChart 
            type="bar"
            title="Phân bố theo aging (số ngày tồn tại)"
            data={agingDistribution}
            height={300}
          />
        </div>
      </div>

      {/* Table */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Danh sách tối giản ({lowRiskWarnings.length} bản ghi)</h4>
            <button className="btn btn-success" onClick={handleExport}>
              <i className="bi bi-download me-2"></i>
              Xuất CSV
            </button>
          </div>
          <ReportTable 
            data={lowRiskWarnings}
            columns={tableColumns}
            onRowClick={(row) => navigate('/warnings', { state: { selectedWarning: row } })}
            pageSize={50}
          />
        </div>
      </div>
    </div>
  );
}

export default LowRiskReport;
